import {DataEntity} from 'octopus-connect';

export class Draft {

    name = '';
    template: number;
    section: number;
    entity: DataEntity;
}
